import type { GallerySearchResult, SearchSuggestion } from '@/types';
import type { SearchGalleryApi, SearchSuggestionApi } from '@/services/SearchApi';

const normalizeSuggestionType = (value: string | undefined): SearchSuggestion['type'] => {
  return ['term', 'gallery', 'category', 'photographer'].includes(value as string)
    ? (value as SearchSuggestion['type'])
    : 'term';
};

export const mapSearchSuggestion = (item: SearchSuggestionApi, index: number): SearchSuggestion => {
  const title = item.value ?? '';

  return {
    id: `${item.type ?? 'suggestion'}-${title}-${index}`,
    title,
    type: normalizeSuggestionType(item.type),
    url: item.url,
  };
};

export const mapGallerySearchResult = (item: SearchGalleryApi): GallerySearchResult => {
  const categoryRaw = item.category;
  const photographerRaw = item.photographer;

  const category =
    typeof categoryRaw === 'object' && categoryRaw !== null
      ? {
          id: String((categoryRaw as { id?: string }).id ?? ''),
          name: String((categoryRaw as { name?: string }).name ?? ''),
        }
      : {
          id: '',
          name: typeof categoryRaw === 'string' ? categoryRaw : 'Uncategorized',
        };

  const photographer =
    typeof photographerRaw === 'object' && photographerRaw !== null
      ? {
          id: String((photographerRaw as { id?: string }).id ?? ''),
          name: String((photographerRaw as { name?: string }).name ?? ''),
          avatar_url: (photographerRaw as { avatar_url?: string }).avatar_url,
        }
      : {
          id: '',
          name: typeof photographerRaw === 'string' ? photographerRaw : 'Unknown',
        };

  return {
    id: String(item.id ?? ''),
    code: String(item.code ?? ''),
    title: String(item.title ?? ''),
    slug: String(item.slug ?? ''),
    main_image_url: String(item.main_image_url ?? ''),
    price: Number(item.price ?? 0),
    photos_count: Number(item.photos_count ?? 0),
    category,
    photographer,
  };
};
